import "@tamagui/core/reset.css";
import "~/i18n";
import "~/sentry.config";
import "../tamagui-web.css";
import "../utils/patch-animated";

import { Suspense, useEffect } from "react";
import { Slot, SplashScreen, usePathname } from "expo-router";
import Hotjar from "@hotjar/browser";
import { BuildVersionWatcher } from "@ptsd/uikit";
import * as Sentry from "@sentry/react-native";
import mixpanel from "mixpanel-browser";
import { TamaguiProvider } from "tamagui";

import { TRPCProvider } from "~/utils/api";
import { GlobalErrorScreen } from "~/component/global-error-screen";
import env from "../config";
import config from "../tamagui.config";

void SplashScreen.preventAutoHideAsync();

export default function Layout() {
  const pathname = usePathname();
  useEffect(() => {
    if (env.HOT_JAR_SITE_ID !== undefined && env.HOTJAR_VERSION !== undefined) {
      Hotjar.init(env.HOT_JAR_SITE_ID, env.HOTJAR_VERSION);
    }
  }, []);

  useEffect(() => {
    if (env.MIXPANEL_TOKEN) {
      console.log("mixpanel init");
      mixpanel.init(env.MIXPANEL_TOKEN, {
        api_host: env.MIXPANEL_DOMAIN ?? "https://api-eu.mixpanel.com",
        cookie_domain: env.MIXPANEL_COOKIE_DOMAIN ?? ".healhymind.help",
        cross_site_cookie: true,
        cross_subdomain_cookie: true,
        autocapture: {
          click: false,
        },
        track_pageview: true,
      });
    }
  }, []);

  useEffect(() => {
    if (Hotjar.isReady()) {
      Hotjar.stateChange(pathname);
    }
  }, [pathname]);

  return (
    <TRPCProvider>
      <TamaguiProvider config={config} defaultTheme={"light"}>
        <BuildVersionWatcher buildCreatedAt={env.BUILD_CREATED_AT} />
        <Sentry.ErrorBoundary
          fallback={({ error }) => (
            <GlobalErrorScreen withHeader error={error.message} />
          )}
        >
          <AppWithSentry />
        </Sentry.ErrorBoundary>
      </TamaguiProvider>
    </TRPCProvider>
  );
}

const App = () => {
  return (
    <Suspense>
      <Slot />
    </Suspense>
  );
};

const AppWithSentry = Sentry.wrap(App);
